// This hook returns the appropriate button URL

import { useSelector } from 'react-redux';
import { selectSiteUrl, selectToolbarConfig } from 'core/selectors/app';
import { isIOS } from 'core/utils/helpers/browser';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';

export const useGetButtonUrl = () => {
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const siteUrl = useSelector(selectSiteUrl);
  const toolbarConfig = useSelector(selectToolbarConfig);
  const { enableButtonMarketingIOS } = toolbarConfig;

  if (isIOS && isMobileMQ && enableButtonMarketingIOS) {
    return `${siteUrl}/mobilebutton`;
  }

  return `${siteUrl}/button`;
};
